import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import BarChartIcon from '@mui/icons-material/BarChart';
import ArticleIcon from '@mui/icons-material/Article';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';

const featureData = [
    {
        image: <BarChartIcon style={{fontSize: "100px", color: "#1ec8ff"}}/>,
        title: 'Generare de Statistici Avansate',
        description: 'Creează statistici complexe și detaliate din rapoartele fiecărei locații. Date precise pentru analize în profunzime.',
    },
    {
        image: <ArticleIcon style={{fontSize: "100px", color: "#1ec8ff"}}/>,
        title: 'Rapoarte Impecabile',
        description: 'Generează rapoarte precise și necontestabile pentru fiecare locație. Date verificabile și statistici complete.',
    },
    {
        image: <SettingsSuggestIcon style={{fontSize: "100px", color: "#1ec8ff"}}/>,
        title: 'Aplicație Mobilă și Web',
        description: 'Aplicația noastră mobilă și platforma web oferă automatizare avansată pentru o monitorizare a securității mai eficientă și mai precisă.',
    },
];

const Feature2 = () => {
    return (
        <section className="text-center">
            <Container className='ps-8 pe-8'>
                <Row>
                    <Col>
                        <div className="p-7 rounded bg-white shadow">
                            <Row className="align-items-center">
                                {featureData.map((feature, index) => (
                                    <Col key={index} xl="4" lg="4" sm="6" className={index !== 0 ? 'mt-6 mt-sm-0' : ''}>
                                        <div>
                                            <div>
                                                {feature.image}
                                            </div>
                                            <h5 className="mt-4 mb-3">{feature.title}</h5>
                                            <p style={{minHeight: "160px"}}>{feature.description}</p>
                                            <Link className="btn-link" to="/" style={{ textDecoration: 'none' }}>
                                                Citește mai multe
                                            </Link>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default Feature2;
